import { useNavigate } from "react-router-dom";
import { Text } from "../../../ui-kit/Text/Text";
import styles from "./Logo.module.scss";

import logoImg from "../../../assets/img/dh-om-transp.png";

export const LogoBlock = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.logoBlock} onClick={() => navigate("/")}>
      <div>
        <img className={styles.logo} src={logoImg} />
      </div>
      <div>
        <Text bold style={{lineHeight: "1.5em"}}> DHARMA1937</Text>
      </div>
    </div>
  );
};
